import Vue from 'vue';
import Component from 'vue-class-component';
import { Status } from '@/models/status.model';
import { STORE } from '@/core/store/core.store';

@Component({
  components:{
    EdListHomeworkLoading: () => import(/* EdListHomeworkLoading */'../ed-list-homework-loading/ed-list-homework-loading.vue'),
    EdHomeworkWidgetCourse: () => import(/* EdHomeworkWidgetCourse */'../ed-homework-widget-course/ed-homework-widget-course.vue'),
  }
})
export default class EdListHomework extends Vue {

  public coursesStatus: Status = new Status();
  public moreCoursesStatus: Status = new Status();

  get courses() {
    return this.$store.state.HomeworksStore.teacherWidgetHomeworks.courses.content;
  }

  get hasMoreCourses() {
    return this.$store.state.HomeworksStore.teacherWidgetHomeworks.courses.more;
  }

  async getCourses(status: Status) {
    try {
      status.setLoading();
      await this.$store.dispatch(STORE.HOMEWORKS.ACTIONS.GET_TEACHER_WIDGET_HOMEWORKS);
      status.setLoad();
    } catch(err) {
      status.setError();
    }
  }

  getMoreCourses() {
    this.getCourses(this.moreCoursesStatus);
  }

  created() {
    if(!this.$store.state.HomeworksStore.teacherWidgetHomeworks.firstLoad) { 
      this.getCourses(this.coursesStatus);
    } else {
      this.coursesStatus.setLoad();
    }
  }

}